<template>
  <div>
    <v-autocomplete
      label="Sales Invoice"
      :items="items"
      item-text="number"
      item-value="id"
      v-model="invoiceId"
      @change="onChange"
      dense
      :outlined="$store.getters.localSettings('outlinedInputs')"
      autocomplete
    ></v-autocomplete>
    <code v-if="debug">{{ salesInvoices }}</code>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
const LIST = gql`
  query simpleSalesInvoiceList {
    salesInvoices {
      edges {
        node {
          id
          number
          clientName
          itineraryReference
        }
      }
    }
  }
`;
export default {
  name: "sales-invoice-list-select",

  props: {
    value: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      invoiceId: this.value != "" ? this.value : "",
    };
  },

  computed: {
    items() {
      return this.salesInvoices && this.salesInvoices.edges
        ? this.salesInvoices.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.invoiceId = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.invoiceId);
    },
  },

  apollo: {
    salesInvoices: {
      query: LIST,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/documents/SalesInvoiceListSelect.vue